import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'

/**
 * Props for {@link NotesSupportingItemInput}.
 */
export type NotesSupportingItemInputProps =
  ModelProps<NotesSupportingItemInput> & { type: 'Notes' }

/**
 * Supporting item input for notes.
 */
export class NotesSupportingItemInput
  extends Model<NotesSupportingItemInput>
  implements SupportingItemInputBase
{
  @observable accessor text = ''

  /** @inheritDoc */
  @computed get isCompleted() {
    return !!this.text.trim()
  }
}
